import Vue from 'vue'
import VueLocalforage from 'v-localforage'

Vue.use(VueLocalforage, {"name":"nuxtJS","storeName":"nuxtLocalForage","instances":[{"name":"OblykDatabase","storeName":"gymRoutes"}]})

export default (ctx, inject) => {
  inject('localForage', Vue.$localforage)
}
